import React, { useState, useEffect } from "react";
import { Col, Row, DatePicker, Card, Form, Spin, Select } from "antd";
import {
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  RiseOutlined,
  StockOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { blue } from "@ant-design/colors";

const DbsSentInvoiceSummary = (props) => {
  const [summaryData, setSummaryData] = useState({
    data: {
      total: props.data.total,
      success: props.data.success,
      error: props.data.error,
      totalAmount: props.data.totalAmount,
      firmBalance: props.firmBalance,
    },
    loading: false,
  });

  useEffect(() => {
    setSummaryData({
      data: {
        total: props.data.total,
        success: props.data.success,
        error: props.data.error,
        totalAmount: props.data.totalAmount,
        firmBalance: props.firmBalance,
      },
      loading: false,
    });
  }, [props]);

  const formatNumber = (number) => {
    number = parseFloat(number);
    let parts = number.toFixed(2).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  };

  return (
    <Row id="summaryArea" style={{ ...props.style }}>
      <Col span={24}>
        <Card>
          <Row align="middle">
            {summaryData.loading ? (
              <Col xs={24} md={12} lg={18} style={{ textAlign: "center" }}>
                <Spin />
              </Col>
            ) : (
              <>
                <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                  <p>
                    <InfoCircleOutlined
                      style={{ color: blue.primary, fontSize: "150%" }}
                    />
                  </p>
                  <h4>Toplam: {summaryData.data.total}</h4>
                </Col>

                <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                  <p>
                    <CheckCircleOutlined
                      style={{ color: "green", fontSize: "150%" }}
                    />
                  </p>
                  <h4>Başarılı: {summaryData.data.success}</h4>
                </Col>

                <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                  <p>
                    <ExclamationCircleOutlined
                      style={{ color: "red", fontSize: "150%" }}
                    />
                  </p>
                  <h4>Hatalı: {summaryData.data.error}</h4>
                </Col>
                <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                  <p>
                    <RiseOutlined
                      style={{ color: "purple", fontSize: "150%" }}
                    />
                  </p>
                  <h4>Tutar: {formatNumber(summaryData.data.totalAmount)}</h4>
                </Col>
                {summaryData.data.firmBalance !== null &&
                  summaryData.data.firmBalance !== undefined && (
                    <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                      <p>
                        <StockOutlined
                          style={{ color: "blue", fontSize: "150%" }}
                        />
                      </p>
                      <h4>
                        Bayi Bakiye:{" "}
                        {formatNumber(summaryData.data.firmBalance)}
                      </h4>
                    </Col>
                  )}
                {summaryData.data.firmBalance !== null &&
                  summaryData.data.firmBalance !== undefined && (
                    <Col xs={24} md={12} lg={4} style={{ textAlign: "center" }}>
                      <p>
                        <MinusCircleOutlined
                          style={{ color: "green", fontSize: "150%" }}
                        />
                      </p>
                      <h4>
                        Fark:{" "}
                        {formatNumber(
                          summaryData.data.totalAmount -
                            summaryData.data.firmBalance
                        )}
                      </h4>
                    </Col>
                  )}
              </>
            )}
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
export default DbsSentInvoiceSummary;
